var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.3882 22.8857H21.8275L15.8834 14.5679L15.1732 13.5708L10.5998 7.17132H8.16048L19.3882 22.8857Z","fill":"#323232","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM23.4161 6L16.7145 13.6226L24 24H18.6398L13.7319 17.0104L7.58786 24H6L13.0278 16.0073L6 6H11.3602L16.0066 12.6172L21.8282 6H23.4161Z","fill":"#323232","key":1})]);
}

Twitter.defaultProps = {"className":"icon-social-svg","width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
